module.exports = __webpack_public_path__ + "img/close-icon.1e729280.svg";